const mobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let canvasWidth = 652;
let canvasHeight = 600;
const canvasMinWidth = 550;
const incrementalScaleValue = 0.1;
const animationSpeed = 1;
const animationStore = {};

let Pan;
let store = {};
let adjustedScale;
let autoLeftMargin;


const getAnimatedValues = (selectedOptions) => {
    if(mobile()) {
        return { ...selectedOptions };
    }

    [
        'panWidth', 'panDepth', 'curbHeight', 'curbWidth',
        'drainBackMeasurement', 'drainSideMeasurement',
    ].forEach((v) => {
        const delta = +(Math.abs(animationStore[v] - selectedOptions[v]));

        if (delta < animationSpeed) {
            animationStore[v] = selectedOptions[v];
        } else if (animationStore[v] < selectedOptions[v]) {
            animationStore[v] += animationSpeed;
        } else if (animationStore[v] > selectedOptions[v]) {
            animationStore[v] -= animationSpeed;
        } else {
            animationStore[v] = selectedOptions[v];
        }
    });

    return { ...animationStore };
};

const renderCompleted = (selectedOptions) => {
    const current = JSON.stringify(store);
    const future = JSON.stringify(selectedOptions);
    return current === future;
};

function getTransformedOptions() {
    const defaultState = {
        drain_position: drain_position.value.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
        drain_finish: 'Polished Chrome',// ?????
        entrance_curbs: entrance_curbs.value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
        brand_name: brand_name.value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
        pan_depth: pan_depth.value,
        pan_width: pan_width.value,
        drain_back_measurement: drain_back_measurement.value,
        drain_side_measurement: drain_side_measurement.value,
        retailer: 'Webstore',
        curb_width: curb_width.value,
        curb_height: curb_height.value,
    };

    return {
        panWidth: +(defaultState.pan_width),
        panDepth: +(defaultState.pan_depth),
        curbWidth: +(defaultState.curb_width),
        curbHeight: +(defaultState.curb_height),
        drainBackMeasurement: +(defaultState.drain_back_measurement),
        drainSideMeasurement: +(defaultState.drain_side_measurement),
        curbType: defaultState.entrance_curbs,
        grateStyle: brandGrateMap[defaultState.brand_name],
        grateFinish: defaultState.drain_finish,
        drainPosition: drainPositionMap[defaultState.drain_position],
        retailer: 'Webstore',
    };
}

//-------------------------------------------------------------------------------------------
// General Code

const form = document.querySelector('form.customizer-calculator--options_form');
const entrance_curbs = form['entrance'];
const drain_position = form['drain-position'][0];
const brand_name = form['brand'];
const pan_depth = form['dimensions'][0];
const pan_width = form['dimensions'][1];
const drain_back_measurement = form['drain-position'][1];
const drain_side_measurement = form['drain-position'][2];
const curb_width = form['curb-dimensions'][0];
const curb_height = form['curb-dimensions'][1];
const canvasRef = document.querySelector('#canvasContainer');

let selectedOptions = getTransformedOptions();

entrance_curbs.forEach(radio => {
    radio.addEventListener('change', reload)
});
brand_name.forEach(radio => {
    radio.addEventListener('change', reload);
});
drain_position.addEventListener('change', reload);
pan_depth.addEventListener('change', reload);
pan_width.addEventListener('change', reload);
drain_back_measurement.addEventListener('change', reload);
drain_side_measurement.addEventListener('change', reload);
curb_width.addEventListener('change', reload);
curb_height.addEventListener('change', reload);

function reload() {
    selectedOptions = getTransformedOptions();
    redraw();
}

function setup() {
    const { scale, leftMargin } = specConfig;
    adjustedScale = scale;

    autoLeftMargin = leftMargin;

    canvasWidth = canvasRef ? canvasRef.offsetWidth : 500;

    createCanvas(canvasWidth, canvasHeight).parent(canvasRef);

    Pan = new PanBuilder(p5, 0, 0, adjustedScale);
    
    if(mobile()) {
        noLoop();
    }
}

function draw () {
    const {
        curbType, grateStyle, drainPosition,
    } = selectedOptions;

    const { topMargin } = specConfig;

    let animatedValues = {};
    if(mobile()){
        animatedValues = selectedOptions;
    } else {
        animatedValues = getAnimatedValues(selectedOptions);
    }

    const {
        panWidth, panDepth, drainBackMeasurement, drainSideMeasurement,
        curbHeight, curbWidth,
    } = animatedValues;


    if (renderCompleted(selectedOptions) && canvasWidth >= canvasRef.offsetWidth) {
        return;
    }

    if (canvasWidth !== canvasRef.offsetWidth) {
        canvasWidth = canvasRef.offsetWidth;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    // Small device adjustments
    if (canvasWidth < canvasMinWidth) {

        canvasWidth = 650;
        canvasHeight = 650;
        autoLeftMargin = 50;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    const inputWidth = +(panWidth);
    const inputDepth = +(panDepth);
    const inputDrainY = +(drainBackMeasurement);
    const inputDrainX = +(drainSideMeasurement);
    const inputCurbWidth = +(curbWidth);
    const inputCurbHeight = +(curbHeight);
    const panDepthScaled = Math.round(inputDepth * adjustedScale);
    const panWidthScaled = Math.round(inputWidth * adjustedScale);

    const frontViewPositionBuffer = topMargin + panDepthScaled + 300;

    if (canvasHeight !== frontViewPositionBuffer) {
        canvasHeight = frontViewPositionBuffer;
        resizeCanvas(canvasWidth, canvasHeight);
    }

    const sideViewBuffer = 300;
    const sideViewPositionBuffer = autoLeftMargin + panWidthScaled + sideViewBuffer;

    const topViewBottomMargin = 130;
    const topViewRightMargin = 150;
    const sideViewPosition = autoLeftMargin + panWidthScaled + topViewRightMargin;
    const frontViewPosition = topMargin + panDepthScaled + topViewBottomMargin;

    // Setup some default canvas state
    background(255);
    fill(0);
    textSize(20);
    stroke('black');
    strokeWeight(0);
    textFont('Droid Sans');
    push();

    stroke('black');
    noFill();
    strokeWeight(1);

    push();

    // Draw Top View of Pan
    translate(autoLeftMargin, topMargin);

    Pan.scale(adjustedScale);
    Pan.dimensions(inputWidth, inputDepth);
    Pan.drainLocation(inputDrainX, inputDrainY, drainPosition);
    Pan.curbType(curbType);

    if (curbType === 'Barrier Free') {
        Pan.curbWidth(0);
        Pan.curbHeight(0);
    } else {
        Pan.curbWidth(inputCurbWidth);
        Pan.curbHeight(inputCurbHeight);
    }

    Pan.splashWallWidth(panBaseSpec.splashWallWidthInches);
    Pan.grateStyle(grateStyle);

    Pan.render('top');

    pop();
    push();

    translate(sideViewPosition, topMargin);
    Pan.render('side');

    pop();
    push();

    translate(autoLeftMargin, frontViewPosition);
    Pan.render('front');

    pop();
    push();
    translate(0, topMargin + 700);

    
    window.PanState = Pan.state;

    const boxBuffer = 50;

    if ((sideViewPositionBuffer >= canvasWidth)) {
        adjustedScale -= incrementalScaleValue;
    } else if ((sideViewPositionBuffer < (canvasWidth - boxBuffer))) {
        adjustedScale += incrementalScaleValue;
    } else {
        store = { ...selectedOptions, ...animatedValues };
    }
}